import { render, staticRenderFns } from "./DiscountPlanListTable.vue?vue&type=template&id=2b10e735&"
import script from "./DiscountPlanListTable.vue?vue&type=script&lang=js&"
export * from "./DiscountPlanListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports